import { useState } from "react";
import OtpInput from "react-otp-input";
import { useSelector } from "react-redux";
import Button from "../../../../../../../../common/Buttons/Button";
import Typography from "../../../../../../../../common/Typography";
import TimerButton from "../../../../../../../../common/Buttons/TimerButton";
import { redirectToDifferentPage } from "../../../../../../../../../utils/constants/constants";
import { sendAndVerifyOtpForMembPurchase } from "../../../../../../../../../redux/actions/shortlinkActions";

const VerifyOtp = ({ state, setState, membershipId }) => {
  const [error, setError] = useState("");
  const [isResendingOTP, toggleResendingOTP] = useState(false);
  const [isVerifyingOTP, toggleVerifyingOTP] = useState(false);

  const initData = useSelector((state) => state?.shortLink?.initData);

  const callingCode = initData?.calling_code ?? "";
  const membPromoId = initData?.membership_promotion_id ?? "";

  const handleResendOTP = () => {
    if (state.customer_mobile.length !== 10) {
      setError("Please enter 10 digit customer mobile");
      return;
    }

    const sendOtpData = {
      membership_setting_id: membershipId,
      membership_promotion_id: membPromoId,
      customer_mobile: state.customer_mobile,
    };

    toggleResendingOTP(true);
    sendAndVerifyOtpForMembPurchase(sendOtpData, true)
      .then(() => {
        setError("");
        setState((prev) => ({ ...prev, otp: "" }));
      })
      .catch((errMsg) => setError(errMsg))
      .finally(() => toggleResendingOTP(false));
  };

  const handleVerifyOTP = () => {
    if (state.otp.length !== 6) {
      setError("Please enter 6 digit OTP");
      return;
    }
    if (state.customer_mobile.length !== 10) {
      setError("Please enter 10 digit customer mobile");
      return;
    }

    const verifyOtpData = {
      otp: state.otp,
      membership_setting_id: membershipId,
      membership_promotion_id: membPromoId,
      customer_mobile: state.customer_mobile,
    };

    toggleVerifyingOTP(true);
    sendAndVerifyOtpForMembPurchase(verifyOtpData)
      .then((payload) => {
        setError("");
        if (payload?.short_url?.length > 0)
          redirectToDifferentPage(payload.short_url, "_self");
        else toggleVerifyingOTP(false);
      })
      .catch((errMsg) => {
        setError(errMsg);
        toggleVerifyingOTP(false);
      });
  };

  return (
    <div className="verify-otp-content">
      <img
        width={40}
        height={40}
        alt="telephone"
        className="speech-balloon"
        src="/assets/images/whatsapp-chat/speech-balloon-2.svg"
      />
      <Typography
        weight="medium"
        size="display-xl"
        customClass="enter-otp-label"
      >
        Enter six digit <br /> OTP you received on
      </Typography>
      <Typography weight="medium" customClass="phone-number">
        {callingCode}-{state.customer_mobile}
      </Typography>
      <OtpInput
        isInputNum
        numInputs={6}
        value={state.otp}
        shouldAutoFocus={true}
        onChange={(otp) =>
          setState((prev) => ({
            ...prev,
            otp: otp,
          }))
        }
        focusStyle={{
          border: "1px solid #04ABAA",
        }}
        containerStyle={{
          margin: "20px 0",
          justifyContent: "space-between",
        }}
        inputStyle={{
          width: "51px",
          outline: "none",
          height: "48.5px",
          fontSize: "16px",
          color: "#697777",
          borderRadius: "7px",
          border: "1px solid #D7DDDD",
          fontFamily: "BasierCircleSemiBold",
          boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
        }}
      />
      {error?.length > 0 && (
        <Typography customClass="error-text">{error}</Typography>
      )}
      <TimerButton
        fullWidth={true}
        initialMinutes={1}
        initialSeconds={0}
        variant="secondary"
        disabled={isResendingOTP}
        customClass="resend-otp-btn"
        handleClick={handleResendOTP}
      />
      <Button
        type="submit"
        fullWidth={true}
        disabled={isVerifyingOTP}
        customClass="verify-otp-btn"
        handleClick={handleVerifyOTP}
        text="Verify & Get Membership"
        isSubmitting={isVerifyingOTP}
      />
    </div>
  );
};
export default VerifyOtp;
